/**
 * Mirrors apps/api/src/config/password-policy.ts.
 *
 * The browser copy exists so the rule can be shown while typing; the API check is the one
 * that decides. Keep the two in step — they disagreed before, and a password the form
 * accepted came back rejected with nothing marked.
 */

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 72;

const SYMBOL = /[^A-Za-z0-9\s]/;
const DIGIT = /[0-9]/;

export interface PasswordRules {
  longEnough: boolean;
  notTooLong: boolean;
  hasDigit: boolean;
  hasSymbol: boolean;
  ok: boolean;
}

export function checkPassword(password: string): PasswordRules {
  const longEnough = password.length >= PASSWORD_MIN_LENGTH;
  // Byte length, matching bcrypt's limit — Georgian characters take three bytes each.
  const notTooLong = new TextEncoder().encode(password).length <= PASSWORD_MAX_LENGTH;
  const hasDigit = DIGIT.test(password);
  const hasSymbol = SYMBOL.test(password);
  return {
    longEnough,
    notTooLong,
    hasDigit,
    hasSymbol,
    ok: longEnough && notTooLong && hasDigit && hasSymbol,
  };
}
